export default () => {
    const urlParams = new URLSearchParams(window.location.search);
    const vendedor = urlParams.get('vendedor')

    return vendedor? `?vendedor=${vendedor}` : ''
}